import * as React from "react";

function MedlineIcon(props) {
  const { className, height, width } = props;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox="0 0 104 28"
    >
      <defs>
        <clipPath>
          <rect width="104" height="28" />
        </clipPath>
      </defs>
      <g clipPath="url(#clip-medline)">
        <path
          data-name="Path 7092"
          d="M-38.222,0h-3.072l-.569-13.159L-44.367,0h-2.922L-44-15.748h4.619L-38.9-4.716l5.371-11.032h4.673L-32.153,0h-2.954L-32-13.062Zm8.831,0L-26.1-15.748h11.677l-.548,2.632h-8.433l-.752,3.577h8.153l-.548,2.632h-8.153L-25.7-2.632h9.163L-17.092,0ZM-15.1,0l3.3-15.748h4.243q1.772,0,2.267.054a6.545,6.545,0,0,1,1.746.4,4.8,4.8,0,0,1,1.4.843,5.309,5.309,0,0,1,1.085,1.305,6.412,6.412,0,0,1,.7,1.756A9.007,9.007,0,0,1-.119-9.217,10.083,10.083,0,0,1-1.091-4.7,8.933,8.933,0,0,1-3.535-1.568,7.355,7.355,0,0,1-6.446-.236,14.839,14.839,0,0,1-9.55,0Zm3.771-2.535H-9.69a10.757,10.757,0,0,0,2.583-.22A3.6,3.6,0,0,0-5.64-3.577,6.957,6.957,0,0,0-4.029-5.9a8.236,8.236,0,0,0,.655-3.416,4.71,4.71,0,0,0-.542-2.519,2.634,2.634,0,0,0-1.337-1.123,6.917,6.917,0,0,0-1.987-.193h-1.88ZM.376,0l3.3-15.748H6.907L4.168-2.632h8.014L11.634,0ZM13.149,0l3.3-15.748H19.68L16.393,0Zm18.4,0H28.532L24.278-10.581,22.065,0H19.047l3.287-15.748h3.029L29.628-5.21l2.2-10.538h3.008Zm2.858,0L37.7-15.748H49.372l-.548,2.632H40.392L39.64-9.539h8.153l-.548,2.632H39.092L38.1-2.632h9.163L46.708,0Z"
          transform="translate(51 21)"
          fill="#0052d6"
        />
      </g>
    </svg>
  );
}

export default MedlineIcon;
